// filter 
document.addEventListener("DOMContentLoaded", function () {

  const form = document.getElementById("CollectionFilterForm");
  const content = document.getElementById("CollectionAjaxContent");

  if (!form || !content) return;

  /**
   * Initialize sort dropdown
   * @param {Function} fetchCallback - function to call when sort changes
   */
  function initSort(fetchCallback) {
    const sortSelect = document.querySelector("#sort_by");
    if (!sortSelect) return;

    // Remove any old listener
    sortSelect.removeEventListener("change", fetchCallback);

    // Attach new listener
    sortSelect.addEventListener("change", fetchCallback);
  }

  /**
   * Reinitialize filter button listeners after AJAX
   */
  function reinitFilterButtons() {
    // Use jQuery if available, otherwise vanilla JS
    if (typeof $ !== 'undefined') {
      $(".filter-open-btn").off('click').on('click', function(event) {
        event.stopPropagation();
        $(".collection-filter").addClass("active");
        $(".filter-window-close-btn").addClass("active");
      });
    } else {
      const filterOpenBtn = document.querySelector('.filter-open-btn');
      if (filterOpenBtn) {
        filterOpenBtn.addEventListener('click', function(event) {
          event.stopPropagation();
          document.querySelector('.collection-filter')?.classList.add('active');
          document.querySelector('.filter-window-close-btn')?.classList.add('active');
        });
      }
    }
  }

  /**
   * Fetch filtered results via AJAX
   */
  function fetchFilteredResults() {
    const form = document.getElementById("CollectionFilterForm");
    const content = document.getElementById("CollectionAjaxContent");
    const section = document.querySelector(".collection-section");
    if (!form || !content || !section) return;

    const sectionId = section.dataset.sectionId;

    // -------------------------------
    // Price range handling
    // -------------------------------
    form.querySelectorAll(".price-hidden-input").forEach(e => e.remove());
    document.querySelectorAll(".filter-price-checkbox:checked").forEach(chk => {
      const min = chk.dataset.min;
      const max = chk.dataset.max;

      const inputMin = document.createElement("input");
      inputMin.type = "hidden";
      inputMin.name = "filter.v.price.gte";
      inputMin.value = min;
      inputMin.classList.add("price-hidden-input");
      form.appendChild(inputMin);

      if (max) {
        const inputMax = document.createElement("input");
        inputMax.type = "hidden";
        inputMax.name = "filter.v.price.lte";
        inputMax.value = max;
        inputMax.classList.add("price-hidden-input");
        form.appendChild(inputMax);
      }
    });

    // -------------------------------
    // Availability toggle
    // -------------------------------
    form.querySelectorAll("input[name='filter.p.available']").forEach(e => e.remove());
    const availabilityToggle = document.querySelector(".switch-toggle-checkbox-input");
    if (availabilityToggle) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "filter.p.available";
      input.value = availabilityToggle.checked ? "1" : "0";
      form.appendChild(input);
    }

    // -------------------------------
    // FormData and URL
    // -------------------------------
    const formData = new FormData(form);

    // Include sort manually if it's outside the form
    const sortSelect = document.querySelector("#sort_by");
    if (sortSelect) {
      formData.set("sort_by", sortSelect.value);
    }

    const params = new URLSearchParams(formData).toString();
    const url = window.location.pathname + "?" + params;

    // Update browser URL
    window.history.pushState({}, "", url);
    content.classList.add("loading");

    // Close filter sidebar on mobile after filtering
    if (typeof $ !== 'undefined') {
      $(".collection-filter").removeClass("active");
      $(".filter-window-close-btn").removeClass("active");
    } else {
      document.querySelector('.collection-filter')?.classList.remove('active');
      document.querySelector('.filter-window-close-btn')?.classList.remove('active');
    }

    // -------------------------------
    // AJAX fetch
    // -------------------------------
    fetch(url + "&section_id=" + sectionId)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newContent = doc.querySelector("#CollectionAjaxContent");
        if (newContent) content.innerHTML = newContent.innerHTML;

        // -------------------------------
        // Reinitialize after AJAX
        // -------------------------------
        initSort(fetchFilteredResults);
        reinitFilterButtons();

        content.classList.remove("loading");
      })
      .catch(err => {
        console.error("Filter error:", err);
        content.classList.remove("loading");
      });
  }

  // -------------------------------
  // Initial setup
  // -------------------------------

  // Filters (checkboxes, availability, price) trigger fetch
  form.addEventListener("change", fetchFilteredResults);

  // Sort dropdown
  initSort(fetchFilteredResults);

  // Initialize filter buttons on page load
  reinitFilterButtons();

});
